import { flightsLocalStore } from "@flights/web-api-utils-universal";
const key = "offers_checkout_data";
const expirationTime = "30m";
const getSessionStorageData = () => (flightsLocalStore.get(key) || {});
export const getOfferCheckoutData = (offerToken) => getSessionStorageData()[offerToken] || undefined;
export const setOfferCheckoutData = (offerToken, stateOrUpdateFn) => {
    const storeData = getSessionStorageData();
    if (typeof stateOrUpdateFn === "function") {
        const currentData = getOfferCheckoutData(offerToken) || {};
        storeData[offerToken] = stateOrUpdateFn(currentData);
    }
    else {
        storeData[offerToken] = stateOrUpdateFn;
    }
    flightsLocalStore.set(key, storeData, { ttl: expirationTime });
};
